import { ReactNode, Suspense, useState } from 'react';

import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { IconAngleRight, IconCalendar } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { Skeleton } from '@ui';

import { RCFRepaymentSchedule } from './RCFRepaymentSchedule/RCFRepaymentSchedule';
import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../modals/fallbackErrorModal/FallbackErrorModal';

export const ViewConfirmFundingPaymentPlan = ({
    offerId,
    drawdownAmount,
    balanceAfterDrawdown,
    isInRepaymentFreePeriod,
    buttonLabel
}: {
    offerId: string;
    drawdownAmount: number;
    balanceAfterDrawdown: number;
    isInRepaymentFreePeriod?: boolean;
    buttonLabel: ReactNode;
}) => {
    const [showPaymentPlan, setShowPaymentPlan] = useState(false);

    return (
        <>
            <Modal
                isOpen={showPaymentPlan}
                onClose={() => setShowPaymentPlan(false)}
                closeIcon
            >
                {showPaymentPlan && (
                    <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                        <Suspense
                            fallback={<Skeleton className="h-xl w-full" />}
                        >
                            <ScheduleContent
                                offerId={offerId}
                                drawdownAmount={drawdownAmount}
                                balanceAfterDrawdown={balanceAfterDrawdown}
                                isInRepaymentFreePeriod={
                                    isInRepaymentFreePeriod
                                }
                            />
                        </Suspense>
                    </ErrorBoundary>
                )}
            </Modal>

            <Button
                variant="tertiary"
                className="px-0"
                onClick={() => setShowPaymentPlan(true)}
            >
                <IconCalendar />
                {buttonLabel}
                <IconAngleRight />
            </Button>
        </>
    );
};

const ScheduleContent = ({
    offerId,
    drawdownAmount,
    balanceAfterDrawdown,
    isInRepaymentFreePeriod
}: {
    offerId: string;
    drawdownAmount: number;
    balanceAfterDrawdown: number;
    isInRepaymentFreePeriod?: boolean;
}) => {
    const { data } = useDrawdownRepaymentSchedule({
        offerId,
        drawdownAmount,
        suspense: true,
        enabled: true
    });

    if (!data) return null;

    return (
        <RCFRepaymentSchedule
            newOutstandingBalance={balanceAfterDrawdown}
            repaymentSchedule={data}
            isInRepaymentFreePeriod={isInRepaymentFreePeriod}
        />
    );
};
